// ============================================================================
// ITALIAN BIBLE PASSAGES - Nuova Riveduta
// ============================================================================
// Passi biblici italiani con riferimenti Strong

export const biblePassagesIt = {
  "Genesi_1": {
    book: "Genesi",
    chapter: 1,
    title: "La Creazione del mondo",
    verses: [
      { number: 1, text: "Nel principio Dio creò i cieli e la terra.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "La terra era informe e vuota, le tenebre coprivano la faccia dell'abisso e lo Spirito di Dio aleggiava sulla superficie delle acque.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Dio disse: «Sia luce!» E luce fu.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "Dio vide che la luce era buona; e Dio separò la luce dalle tenebre.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Dio chiamò la luce «giorno» e le tenebre «notte». Fu sera, poi fu mattina: primo giorno.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "Poi Dio disse: «Vi sia una distesa tra le acque, che separi le acque dalle acque».", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "Dio fece la distesa e separò le acque che erano sotto la distesa dalle acque che erano sopra la distesa. E così fu.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "Dio chiamò la distesa «cielo». Fu sera, poi fu mattina: secondo giorno.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Dio creò l'uomo a sua immagine; lo creò a immagine di Dio; li creò maschio e femmina.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Dio vide tutto quello che aveva fatto, ed ecco, era molto buono. Fu sera, poi fu mattina: sesto giorno.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Salmo_23": {
    book: "Salmi",
    chapter: 23,
    title: "Il SIGNORE è il mio pastore",
    verses: [
      { number: 1, text: "Il SIGNORE è il mio pastore: nulla mi mancherà.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Egli mi fa riposare in verdeggianti pascoli, mi guida lungo le acque calme.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Egli mi ristora l'anima, mi conduce per sentieri di giustizia, per amore del suo nome.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Quand'anche camminassi nella valle dell'ombra della morte, io non temerei alcun male, perché tu sei con me; il tuo bastone e la tua verga mi danno sicurezza.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Tu apparecchi davanti a me la mensa in presenza dei miei nemici; tu cospargi d'olio il mio capo; la mia coppa trabocca.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Per certo beni e bontà m'accompagneranno tutti i giorni della mia vita; e io abiterò nella casa del SIGNORE per lunghi giorni.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Giovanni_3": {
    book: "Giovanni",
    chapter: 3,
    title: "Gesù e Nicodemo",
    verses: [
      { number: 16, text: "Perché Dio ha tanto amato il mondo, che ha dato il suo unigenito Figlio, affinché chiunque crede in lui non perisca, ma abbia vita eterna.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Infatti Dio non ha mandato suo Figlio nel mondo per giudicare il mondo, ma perché il mondo sia salvato per mezzo di lui.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Chi crede in lui non è giudicato; chi non crede è già giudicato, perché non ha creduto nel nome dell'unigenito Figlio di Dio.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filippesi_4": {
    book: "Filippesi",
    chapter: 4,
    title: "La pace di Dio",
    verses: [
      { number: 4, text: "Rallegratevi sempre nel Signore. Ripeto: rallegratevi.", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Non angustiatevi di nulla, ma in ogni cosa fate conoscere le vostre richieste a Dio in preghiere e suppliche, accompagnate da ringraziamenti.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "E la pace di Dio, che supera ogni intelligenza, custodirà i vostri cuori e i vostri pensieri in Cristo Gesù.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Io posso ogni cosa in Cristo che mi fortifica.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesIt;
